(function ($) {
    $(document).ready(function() {
      
      var taxEvents = drupalSettings.irbradix.taxEvents;
      
          // Selecciona el filtro de la view events
          if (window.location.pathname.search("events")>-1){
            var hash = window.location.hash.replace("#","");
            hash = hash.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            var select = document.getElementsByTagName("select")[0];
            for (var arrayKey in taxEvents) {
              var key = arrayKey.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
              key = key.replace(/\s+/g, '-').toLowerCase();
              if (key == hash){
                for (var i = 0; i < select.options.length; i++) {
                  var optionValue = select.options[i].getAttribute('value');
                  if (taxEvents[arrayKey] == +optionValue){
                    select.options[i].selected = true;
                    document.getElementById("edit-submit-view-events").click();
                    $( document ).ajaxComplete(function () {
                      if ( $('.select').length == 0) {
                        $(this).customSelect();
                      }
                    });
                  }
                }
              }
            };
        };
    });
})(jQuery);